export const BRAND_RETAIL_SALES_SETTINGS_TAB = {
  ADD_ONS: { id: 1, path: 'add-ons' },
} as const
